import { css } from 'styled-components';
import theme from '@resultadosdigitais/tangram-design-tokens';
import { hexToRGB } from '../../helper';
import { kinds } from '../constant';
const themeTokens = theme('lina');
const HighlightStyle = css(["", " ", " ", ""], _ref => {
  let {
    $kind
  } = _ref;
  return $kind === kinds.primary && css(["background-color:rgba(", ",0.9);color:var(--highlight-text);svg > *:not(defs),svg > *:not(defs) *{fill:var(--highlight-icon);}&:hover,&:active,&:focus{&:not([disabled]){color:var(--highlight-text);background-color:var(--neutral-surface);text-decoration:none;}}", ""], hexToRGB(themeTokens.neutralSurface), _ref2 => {
    let {
      $loading
    } = _ref2;
    return !$loading && css(["&:disabled{color:var(--highlight-text);background-color:rgba( ", ",0.4 );}"], hexToRGB(themeTokens.neutralSurface));
  });
}, _ref3 => {
  let {
    $kind
  } = _ref3;
  return $kind === kinds.secondary && css(["background-color:transparent;border-color:rgba(", ",0.9);color:rgba(", ",0.9);&,&:hover:not([disabled]),&:active:not([disabled]),&:focus:not([disabled]){svg > *:not(defs),svg > *:not(defs) *{fill:var(--neutral-icon-inverse);}}&:hover,&:active,&:focus{&:not([disabled]){color:var(--neutral-text-inverse);background-color:rgba(", ",0.15);border-color:rgba(", ",1);}}", ""], hexToRGB(themeTokens.neutralSurface), hexToRGB(themeTokens.neutralSurface), hexToRGB(themeTokens.neutralSurface), hexToRGB(themeTokens.neutralSurface), _ref4 => {
    let {
      $loading
    } = _ref4;
    return !$loading && css(["&:disabled{color:rgba(", ",0.4);border-color:rgba(", ",0.4);}"], hexToRGB(themeTokens.neutralTextInverse), hexToRGB(themeTokens.neutralSurface));
  });
}, _ref5 => {
  let {
    $kind
  } = _ref5;
  return [kinds.tertiary, kinds.neutral].includes($kind) && css(["background-color:transparent;border-color:transparent;color:rgba(", ",0.9);&,&:hover:not([disabled]),&:active:not([disabled]),&:focus:not([disabled]){svg > *:not(defs),svg > *:not(defs) *{fill:var(--neutral-icon-inverse);}}&:hover:not([disabled]),&:active:not([disabled]),&:focus:not([disabled]){background-color:rgba(", ",0.15);color:var(--neutral-text-inverse);}", ""], hexToRGB(themeTokens.neutralTextInverse), hexToRGB(themeTokens.neutralSurface), _ref6 => {
    let {
      $loading
    } = _ref6;
    return !$loading && css(["&:disabled{color:rgba(", ",0.4);}"], hexToRGB(themeTokens.neutralTextInverse));
  });
});
export default HighlightStyle;